module.exports = __webpack_public_path__ + "img/tutorial-f06-01.aaecdb4f.png";